<ng-container *ngIf="alert?.AlertTypeName=='stock' || alert?.AlertTypeName=='fund'">
    <li class="my-1 alert alert--watchlist {{alert ? 'alert--active' : ''}}">
    
        <div class="alert-header">
            <h6 class="alert-title">{{ alert?.PortfolioName }}</h6>
            <span class="alert-date">{{ getAnalysisDate(alert?.AnalysisDate) | date:'EEE, dd MMM' }}</span>
        </div>
        <h6 class="alert-subtitle"  *ngIf="alert?.Country">
            <a [routerLink]="['/explore', alert.AlertTypeName + 's', alert?.ISIN || alert?.Isin,alert?.Country]" (click)="closeMenu()">
                {{ alert?.Name || alert?.CompanyName }} ({{alert?.Country}})
            </a>
        </h6>
        <h6 class="alert-subtitle" *ngIf="alert?.RefCountry">
            <a [routerLink]="['/explore', alert.AlertTypeName + 's', alert?.ISIN || alert?.Isin,alert?.RefCountry]" (click)="closeMenu()">
                {{ alert?.Name || alert?.CompanyName }} ({{alert?.RefCountry}})
            </a>
        </h6>
        <p class="alert-text">
             <span *ngIf="alert.LastCompare == 'Up' && alert.AlertTypeName=='stock'">
                {{ 'Alerts.supgrade' | translate }}
            </span>
            <span *ngIf="alert.LastCompare != 'Up' && alert.AlertTypeName=='stock'">
                {{ 'Alerts.sdowngrade' | translate }}
            </span>
            <span *ngIf="alert.LastCompare == 'Up' && alert.AlertTypeName=='fund'">
                {{ 'Alerts.fupgrade' | translate }}
            </span>
            <span *ngIf="alert.LastCompare != 'Up' && alert.AlertTypeName=='fund'">
                {{ 'Alerts.fdowngrade' | translate }}
            </span>
        </p>
    </li>
</ng-container>
<ng-container *ngIf="alert?.AlertTypeName=='stockandfund'">
    <li class="my-1 alert alert--watchlist {{alert ? 'alert--active' : ''}}">
    
        <div class="alert-header">
            <h6 class="alert-title">{{ alert?.PortfolioName }}</h6>
            <span class="alert-date">{{ getAnalysisDate(alert?.createdAt) | date:'EEE, dd MMM' }}</span>
        </div>
        <h6 class="alert-subtitle"  *ngIf="alert?.ItemType">
            <a [routerLink]="['/explore', alert?.Type.toLowerCase() + 's', alert?.ISIN]" (click)="closeMenu()">
                {{ alert?.ItemType }}
            </a>
        </h6>
        <p class="alert-text">
             <span>
                {{ alert?.Comments}}
            </span>   
        </p>
    </li>
</ng-container>